import { render, staticRenderFns } from "./testQrCodeGoogle.vue?vue&type=template&id=54b1e4b0&"
import script from "./testQrCodeGoogle.vue?vue&type=script&lang=js&"
export * from "./testQrCodeGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports